module.exports = __webpack_public_path__ + "static/img/img3.01cce5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img3.png
// module id = 5MsP
// module chunks = 1